'use client';

import { EntitlementAccessDialog } from '@/components/entitlement-access-dialog';

type SessionAccessDialogVariant = 'login' | 'limit';

interface SessionAccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  variant: SessionAccessDialogVariant;
  language?: string;
  level?: string | null;
  limit?: number;
}

export function SessionAccessDialog({ open, onOpenChange, variant, level }: SessionAccessDialogProps) {
  return (
    <EntitlementAccessDialog
      open={open}
      onOpenChange={onOpenChange}
      level={variant === 'login' ? 'L0' : level}
    />
  );
}
